import { render, staticRenderFns } from "./recaudacionadmin.vue?vue&type=template&id=8e7c274a"
import script from "./recaudacionadmin.vue?vue&type=script&lang=js"
export * from "./recaudacionadmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports